

export const signupCredentialSchema = {
    FullName:"",
    OTP:"",
    userid:"",
    OTPCode:"",
}

